//src/pages/REG/REG300F1.jsx

import React, {useContext, useEffect, useState, useRef} from 'react';
import style from "./REG300F1.module.scss";
import toast from "components/Toast/Toast";
import Button from "components/Button/Button";

import Render1Html from './REG300F2';
import Render2Html from './REG300F3';
import Render3Html from './REG300F4';
import Render4Html from './REG300F5';
import Render5Html from './REG300F6';
import Render6Html from './REG300F7';
import {postData} from 'utils/TransactionUtil';
import styleCom from "./REGCOM.module.scss";
import Modal from "components/Modal/Modal";
import REG300M1 from "./REG300M1"; //자동쿼리
import REG300M2 from "./REG300M2"; //수동쿼리
import regJson from 'assets/json/frmReg_data.json';
import {AuthContext} from "../../contexts/AuthContext";
import {MenuContext} from "../COM/COM001L1";


/* TAB 구성 */
function Sidebar({ tabs, activeTabId, onTabClick }) {
    return (
      <ul className={style.tabList}>
        {tabs.map((tab) => (
          <li key={tab.id} className={`${style.tabItem} ${activeTabId === tab.id ? style.activeTab : ''}`}
              onClick={() => onTabClick(tab.id)}
          >
              {tab.label}
          </li>
         ))}
      </ul>
    );
}


/* ************************************************************************************
*************************************************************************************** */

const REG300F1 = ({navBar: NavBar, mstId, hsptCd, colKey}) => {
    const [workId, setWorkId] = useState(mstId);
    const [workHsptCd, setWorkHsptCd] = useState(hsptCd);
    const [workStartPage, setWorkStartPage] = useState(colKey);

    const [dsOgMst,setDsOgMst] = useState([]);
    const [dsOgDtl,setDsOgDtl] = useState([]);
    const [dsMst,setDsMst] = useState([]);
    const [dsDtl,setDsDtl] = useState([]);

    const authContext = useContext(AuthContext);
    const userInfo = authContext.userInfo; // 사용자 정보 가져오기
    const [isHasPermission, setIsHasPermission] = useState(
        (userInfo.roleId === '100001' || userInfo.roleId === '300001')
    );

    const [isModalOpen, setIsModalOpen] = useState(false); //모달 오픈여부
    const [isModalOpen_manual, setIsModalOpen_manual] = useState(false); //모달 오픈여부
    const { addPage_manual } = useContext(MenuContext);

    const dtlObj = [
        { name: 'mstId', value: ''},
        { name: 'hsptCd', value: ''},
        { name: 'subjectSno', value: ''}

    ];

    const activeFlagObj    = regJson.activeFlagObj;

    /*
     *
     * DTL에 속하지 않고 MST에 속하는 컴포넌트들에 대한 활성, 비활성화를 위하여 사용함
     * mstActiveFlagObj 는 각 컴포넌트 이벤트 발생시 사용되며
     * mstActiveViewObj 는 activeFlag를 저장하여 실제로 컴포넌트에서 readOnly와 같은 플래그값으로 사용됨
     * 상세 데이터 같은 경우에는 별도로 플래그 필드가 있으나 mst에 소속된 항목은
     * 별도 플래그 저장공간이 없어서 선언하여 사용함
     * 각 컴포넌트의 이벤트 관련은 regJson.mstActiveFlagObj 에 정의하고      
     * 펑션을들 만들어서 다음과 같이 사용 getMstActiveFlag, setMstActiveFlag
     * initialMstItemActiveFlag 은 최초 데이터 로드 후 활성,비활성 상태값 변경만을 위하여 사용하며 
     * 컴포넌트 이벤트에 연결된 부분은 REG300F7에서 mstActiveEvent 처럼 따로 선언해서 사용함
   */
    const mstActiveFlagObj = regJson.mstActiveFlagObj;
    const [mstActiveViewObj, setMstActiveViewObj]= useState([
            { mapCd: 'dropReasonStat', activeFlag: 1}
          ]);

    //폼 로드
    useEffect(() => {
        svcSubjectData(workId).then(() => {
        });
    }, []);

    //AUTO Query 체크

    const [autoCheckObj, setAutoCheckObj] = useState([]);

    /* Call Service ****************************************************************************** */
    async function svcGetComItem() {
        let param = {

        }
        let result = await postData("/RED/getWorkInitData", param);
        setDsOgMst(result.outDsInitMst);
        setDsOgDtl(result.outDsInitDtl);

    }
    async function svcSubjectData() {
        let param = {
             mstId:workId
            ,hsptCd:workHsptCd
        }
        let result = await postData("/RED/getSubjectData", param);
        setDsMst(result.outDs1);
        setDsDtl(result.outDs2);

        //activeEvent
        //mst (필드식이여서 단건 호출)
        mstActiveFlagObj.forEach(item => {
          initialMstItemActiveFlag(item.mapCd, result?.outDs1?.[0]?.[item.mapCd]);

        });



        //dtl
        result.outDs2.forEach(item => {
            initialItemState(item.mapCd, item.itmRslt);
        });


        //Subject list 에서 페이지 선택시 해당 탭으로 연결
        let startTab = "";
        switch (workStartPage) {
            case "task1Stat"  : startTab = "T1";  break;
            case "task12Stat" : startTab = "T12"; break;
            case "task2Stat"  : startTab = "T2";  break;
            case "task3Stat"  : startTab = "T3";  break;
            case "task4Stat"  : startTab = "T4";  break;
            case "task5Stat"  : startTab = "T5";  break;
            case "task6Stat"  : startTab = "T6";  break;
            case "task7Stat"  : startTab = "T7";  break;
            case "task8Stat"  : startTab = "T8";  break;
            case "task9Stat"  : startTab = "T9";  break;
            case "task10Stat" : startTab = "T10" ;  break;
            case "task11Stat" : startTab = "T11" ;  break;
            case "task13Stat" : startTab = "T13" ;  break;
            case "task99Stat" : startTab = "T99" ;  break;

            default: startTab = "T0" ; break;
        }
        setActiveTabId(startTab);


    }

    const svcSaveData = async (dsMstCopy) => {

        const mstParam = dsMstCopy;
        const dtlParam = dsDtl.filter(item => item.itmRslt !== null && item.itmRslt !== "");
        const paramList = {
            mstParam: mstParam,
            dtlParam: dtlParam
        };

        let result = await postData("/RED/saveSubjectData", paramList);


    }

    //데이터 셋팅 및 유효성 검사
    const prepareSaveQuality = () => {
        let valid = "";
        /* 탭 구분: T1 | 항목구분코드(추후 카테고리코드 사용) | 항목명 | MapCd 1,2,3...
        * 오브젝트를 기준으로 값을 체크 하고, 상태값 처리를함
        */



        return  valid;
    };

    /* ****************************************************************************** Call Service */


    /* User Function ****************************************************************************** */

    //데이터 get, set
    const getMstValue = (colName) =>{
        const targetItem = dsMst.find(item => item.mstId === workId);
        if (targetItem && targetItem.hasOwnProperty(colName)) {
            return targetItem[colName];
        } else {
            return ""; // 또는 다른 적절한 값 (null, 에러 처리 등)
        }
    }
    const setMstValue = (colName, newValue) => {
        setDsMst(prevData =>
          prevData.map(item =>
            item.mstId === workId? { ...item, [colName]:newValue } : item
          )
        );
    };
    //데이터 get, set
    const getDtlValue = (mapCd, colName='itmRslt') =>{
        const targetItem = dsDtl.find(item => item.mapCd === mapCd);
        if (targetItem && targetItem.hasOwnProperty(colName)) {
            return targetItem[colName] ?? "";
        } else {
            return ""; // 또는 다른 적절한 값 (null, 에러 처리 등)
        }
    }
    const setDtlValue = (mapCd, newValue, colName='itmRslt') => {
        setDsDtl(prevData =>
          prevData.map(item =>
            item.mapCd === mapCd? { ...item, [colName]:newValue } : item
          )
        );

    };

    const initialItemState = (mapCd, value="") =>{

        const matchedObj = activeFlagObj.filter(item =>
          item.mapCd === mapCd && item.chkFlag==='matched' && item.chkVal === value
        );
        const notMatchedObj = activeFlagObj.filter(item =>
          item.mapCd === mapCd && item.chkFlag==='notMatched'
        );

        if(matchedObj.length > 0){
            matchedObj.forEach(item => {
                if(matchedObj.length > 0 && item.chkVal === value){
                    setDtlValue(item.tarId, item.tarFlag, 'activeFlag');
                }
            });
        }else if(notMatchedObj.length > 0){
            // if(mapCd==='M00010'){
            //     console.log(mapCd + " : ");
            // }

            notMatchedObj.forEach(item => {
                setDtlValue(item.tarId, item.tarFlag, 'activeFlag');
                // if(item.mapCd ==='M00010'){
                //     console.log("수행");
                //     console.log(item.tarFlag);
                // }
            });
        }

    }

    const getMstActiveFlag = (targetMapCd) => {
        // 1. setMstActiveViewObj 배열에서 mapCd가 일치하는 객체를 찾습니다.
        const foundItem = mstActiveViewObj.find(item => item.mapCd === targetMapCd);
        return foundItem ? foundItem.activeFlag : 0;
    };
    const setMstActiveFlag = (targetMapCd, newFlag) => {
        setMstActiveViewObj(prevList =>
          prevList.map(item =>
            item.mapCd === targetMapCd
              ? { ...item, activeFlag: newFlag } // 1. mapCd가 일치하면 activeFlag만 새 값으로 변경
              : item                             // 2. 일치하지 않으면 기존 데이터 유지
          )
        );
    };


    const initialMstItemActiveFlag = (mapCd, value="") =>{
        const matchedObj = mstActiveFlagObj.filter(item =>
          item.mapCd === mapCd && item.chkFlag==='matched' && item.chkVal === value
        );
        const notMatchedObj = mstActiveFlagObj.filter(item =>
          item.mapCd === mapCd && item.chkFlag==='notMatched'
        );

        if(matchedObj.length > 0){
            matchedObj.forEach(item => {
                if(matchedObj.length > 0 && item.chkVal === value){
                    setMstActiveFlag(item.tarId, item.tarFlag, 'activeFlag');
                }
            });
        }else if(notMatchedObj.length > 0){
            notMatchedObj.forEach(item => {
                setMstActiveFlag(item.tarId, item.tarFlag, 'activeFlag');
            });
        }

    }




    const formatDate = (dateString) => {
        return `${dateString.slice(0, 4)}-${dateString.slice(4, 6)}-${dateString.slice(6, 8)}`;
    };

    const getStatDisplay = (statCd) =>{
        let resultStat = '';
        switch (statCd) {
            case 'A':  resultStat = '🔴';  break;
            case 'B':  resultStat = '🔵';  break;
            case 'C':  resultStat = '🟢';  break;
            default:
                break;
        }

        return resultStat;
    }


    //Tab 구성
    let stat1 = getStatDisplay(getMstValue('task1Stat'));
    let stat12 = getStatDisplay(getMstValue('task12Stat'));
    let stat2 = getStatDisplay(getMstValue('task2Stat'));
    let stat3 = getStatDisplay(getMstValue('task3Stat'));
    let stat4 = getStatDisplay(getMstValue('task4Stat'));
    let stat5 = getStatDisplay(getMstValue('task5Stat'));
    let stat6 = getStatDisplay(getMstValue('task6Stat'));
    let stat7 = getStatDisplay(getMstValue('task7Stat'));
    let stat8 = getStatDisplay(getMstValue('task8Stat'));
    let stat9 = getStatDisplay(getMstValue('task9Stat'));
    let stat10 = getStatDisplay(getMstValue('task10Stat'));
    let stat11 = getStatDisplay(getMstValue('task11Stat'));
    let stat13 = getStatDisplay(getMstValue('task13Stat'));
    let stat99 = getStatDisplay(getMstValue('task99Stat'));

    const tabs = [
        { id: 'T0', label: 'Demographics', content: 'Demographics Content Here' },
        { id: 'T1', label: (stat1  + ' Admission'), content: 'Admission Content Here' },
        { id: 'T12',label: (stat12 + ' Lab Data'), content: 'Lab Data Content Here'},
        { id: 'T2', label: (stat2  + ' CAG'), content: 'CAG Content Here' },
        { id: 'T3', label: (stat3  + ' 1st Lesion'), content: '1st Lesion Content Here' },
        { id: 'T4', label: (stat4  + ' 2nd Lesion'), content: '2nd Lesion Content Here' },
        { id: 'T5', label: (stat5  + ' 3rd Lesion'), content: '3rd Lesion Content Here' },
        { id: 'T6', label: (stat6  + ' 4th Lesion'), content: '4th Lesion Content Here' },
        { id: 'T7', label: (stat7  + ' Discharge'), content: 'Discharge Content Here' },
        { id: 'T8', label: (stat8  + ' 1M FU'), content: '1th FU Content Here' },
        { id: 'T9', label: (stat9  + ' 6M FU'), content: '6th FU Content Here' },
        { id: 'T10',label: (stat10 + ' 12M FU'), content: '12th FU Content Here' },
        { id: 'T11',label: (stat11 + ' FU Angiography'), content: 'FU Angiography Content Here' },
        { id: 'T13',label: (stat13 +' Clinical Event'), content: 'Clinical Event Content Here' },
        { id: 'T99',label: (stat99 + ' End of Study'), content: 'End of Study Content Here' }
    ];


    // 상태값 체크 *******************
    const stateItemObj = regJson.stateItemObj;

    //const stateResultObj = [
    const resultObj = [
        { contentId: 'T1',  checkState: '' }
        ,{ contentId: 'T2',  checkState: '' }
        ,{ contentId: 'T3',  checkState: '' }
        ,{ contentId: 'T4',  checkState: '' }
        ,{ contentId: 'T5',  checkState: '' }
        ,{ contentId: 'T6',  checkState: '' }
        ,{ contentId: 'T7',  checkState: '' }
        ,{ contentId: 'T8',  checkState: '' }
        ,{ contentId: 'T9',  checkState: '' }
        ,{ contentId: 'T10', checkState: '' }
        ,{ contentId: 'T11', checkState: '' }
        ,{ contentId: 'T12', checkState: '' }
        ,{ contentId: 'T13', checkState: '' }
    ];

    const updateWorkState = () => {

        // dsMst 복사본 만들기 (깊은 복사, 필요한 깊이만큼)
        const dsMstCopy = dsMst.map(item => ({ ...item }));

        // 내부 함수: setMstValue_new처럼 dsMstCopy 수정
        const setMstValue_new = (colName, newValue) => {
            for (let item of dsMstCopy) {
                if (item.mstId === workId) {
                    item[colName] = newValue;
                    break;
                }
            }
        };

        const getMstValue_new = (colName) => {
            const target = dsMstCopy.find(item => item.mstId === workId);
            return target && target.hasOwnProperty(colName) ? target[colName] : "";
        };


        const updatedStatusObj = stateItemObj.map((row) => {

            // [예외 조건 추가]
            // 관리번호 : A0024  요청일 : 2026-06-16
            // FU angiography탭 항목들의 값이 'Not done'이면 나머지 항목들은 체크 패스
            if (getDtlValue("M09001") === '2' && row.contentId === 'T11') {
                return { ...row, isChecked: true };
            }

            // 관리번호 : A0025  요청일 : 2026-06-16
            // End of Study 임상연구 종료의 임상연구 완료여부가 중도탈락일 경우만 중도 탈락사유 아이템 체크
            if (getMstValue("studyEndStat") !== '3'
                && row.contentId === 'T99' && row.chkItem === 'I003') {
                return { ...row, isChecked: true };
            }




            // mcd 필드만 추출
            const mcdKeys = Object.keys(row).filter((key) => key.startsWith('mcd_'));


            // 조건에 따라 isChecked 계산
            // 1.별도 예외처리([요청:A0022]수정요청에 의하여 2026-03-05 추가함) :
            //  - Clinical Event 이상반응-1 종료일의 경우 결과 > 상태값이 3,4,6 일때는 체크하지 않음
            //  - 3,4,6일때는 체크값을 'PASS'로 지정하여 값이 있는걸로 판단처리
            //
            // 2.studyEndDt, studyEndStat, signatureNm 의 경우 MST 데이터필요
            // DTL 데이터와 코드방식이 달라서 필드명으로 구분함
            const isChecked = mcdKeys.some((key) => {
                const rawMapCd = row[key];

                // 빈 값 검사 가드 클로즈
                if (rawMapCd === '' || rawMapCd === null || rawMapCd === undefined) {
                    return false;
                }

                if (rawMapCd !== '' && rawMapCd !== null) {
                    let val = "";
                    if(rawMapCd==="M12003"){
                        const itemM12003Value=getDtlValue("M12010");

                        if(itemM12003Value==='3' || itemM12003Value==='4' || itemM12003Value==='6'){
                            val = 'PASS';
                        }else{
                            val = getDtlValue(rawMapCd);
                        }

                    }else if(rawMapCd==='studyEndDt' || rawMapCd==='studyEndStat' || rawMapCd==='signatureNm'){
                        val = getMstValue(rawMapCd);
                    }else{
                        val = getDtlValue(rawMapCd);
                    }

                    return val !== '' && val !== null && val !== '0';
                }
                return false;
            });

            // 1단계 결과 로그 출력
            //console.log(`✅ contentId: ${row.contentId}, chkItem: ${row.chkItem}, isChecked: ${isChecked}`);
            //console.log("contentId: " + row.contentId);


            // if(row.contentId==="T2"){
            //     console.log(`✅ contentId: ${row.contentId}, chkItem: ${row.chkItem}, isChecked: ${isChecked}`);
            // }

            // isChecked 필드 추가된 row 반환
            return { ...row, isChecked };
        });

        //체크리스트 상세내역 저장
        setAutoCheckObj(updatedStatusObj.filter(row => {
            if (getDtlValue('M02000') ==='1' && row.contentId === 'T4') return false;
            if (getDtlValue('M03000') ==='1'  && row.contentId === 'T5') return false;
            if (getDtlValue('M04000') ==='1'  && row.contentId === 'T6') return false;
            if (getDtlValue('M12000') ==='1'  && row.contentId === 'T13') return false;
            if (row.isChecked===true) return false;
            return true;
        }));

        // 그룹화: updatedStatusObj에서 contentId별로 묶기
        //const [grouped, setGrouped] = userState([]);
        const grouped = [];
        updatedStatusObj.forEach((row) => {
            if (!grouped[row.contentId]) grouped[row.contentId] = [];
            grouped[row.contentId].push(row);
        });
        // const addGroup = {contentId:""};
        // setGrouped([...grouped, addGroup]);



        // resultObj 업데이트: 비교값 없으면 '' 처리
        const updatedResultObj = resultObj.map((result) => {
            const groupRows = grouped[result.contentId];

            if(getDtlValue('M02000') === '1' && result.contentId === 'T4'){
                return { ...result, checkState: 'B'};
            }else if(getDtlValue('M03000') === '1' && result.contentId === 'T5'){
                return { ...result, checkState: 'B'};
            }else if(getDtlValue('M04000') === '1' && result.contentId === 'T6'){
                return { ...result, checkState: 'B'};
            }else if(getDtlValue('M12000') === '1' && result.contentId === 'T13'){
                return { ...result, checkState: 'B'};
            }else if (!groupRows || groupRows.length === 0) {
                //console.log(`contentId: ${result.contentId} → 비교할 row 없음 → checkState: ''`);
                return { ...result, checkState: ''};
            }


            const allTrue = groupRows.every((row) => row.isChecked === true);
            const checkState = allTrue ? 'C' : 'A';

            //console.log(`🔍 contentId: ${result.contentId} → checkState: ${checkState}`);
            return { ...result, checkState };
        });

        updatedResultObj.forEach(({ contentId, checkState }) => {
            switch (contentId) {
                case 'T1':   setMstValue_new('task1Stat', checkState);  break;
                case 'T12':  setMstValue_new('task12Stat', checkState); break;
                case 'T2':   setMstValue_new('task2Stat', checkState);  break;
                case 'T3':   setMstValue_new('task3Stat', checkState);  break;
                case 'T4':   setMstValue_new('task4Stat', checkState);  break;
                case 'T5':   setMstValue_new('task5Stat', checkState);  break;
                case 'T6':   setMstValue_new('task6Stat', checkState);  break;
                case 'T7':   setMstValue_new('task7Stat', checkState);  break;
                case 'T8':   setMstValue_new('task8Stat', checkState);  break;
                case 'T9':   setMstValue_new('task9Stat', checkState);  break;
                case 'T10':  setMstValue_new('task10Stat', checkState);  break;
                case 'T11':  setMstValue_new('task11Stat', checkState);  break;
                case 'T13':  setMstValue_new('task13Stat', checkState);  break;
                default:
                    //console.log(` [기타 그룹 ${contentId}] 상태: ${checkState}`);
                    // 필요하면 추가 case로 확장 가능
                    break;
            }

            //예외처리 Lesion
            if(getDtlValue('M02000')==='1'){
                setMstValue_new('task4Stat', "B")
            }
            if(getDtlValue('M03000')==='1'){
                setMstValue_new('task5Stat', "B")
            }
            if(getDtlValue('M04000')==='1'){
                setMstValue_new('task6Stat', "B")
            }

            //T99 추가로직
            if(    ( getMstValue_new('studyEndDt') !=='' && getMstValue_new('studyEndDt') !== null)
              && ( getMstValue_new('studyEndStat') !=='' && getMstValue_new('studyEndStat') !== null)
              && ( getMstValue_new('signatureYn') ==='Y'
                && getMstValue_new('signatureYn') !== '' && getMstValue_new('signatureYn') !== null)
            ){
                setMstValue_new('task99Stat', "C")
            }else{
                setMstValue_new('task99Stat', "A")
            }

        });


        setDsMst(dsMstCopy);
        return dsMstCopy
    }


    /* ****************************************************************************** User Function */


    /* TabPage Area ****************************************************************************** */


    const [activeTabId, setActiveTabId] = useState(tabs[0]?.id || null);
    // 활성화된 탭의 내용을 효율적으로 찾기 위해 useMemo 사용(activeTabId가 변경될 때만 다시 계산)

    //탭 클릭시 스크롤 제일 위로 처리
    const contentRef = useRef(null);
    useEffect(() => {
        if (contentRef.current) {
            contentRef.current.scrollTop = 0;
        }
    }, [activeTabId]);


    // 탭 클릭 핸들러
    const handleTabClick = (tabId) => {
        setActiveTabId(tabId);

    };


    function mainContent(contentId) {

        switch (contentId) {
            case "T0": case "T1": case "T2": case "T12":
                return (
                  <Render1Html contentId={contentId}     activeFlagObj={activeFlagObj}
                               getMstValue={getMstValue} setMstValue={setMstValue}
                               getDtlValue={getDtlValue} setDtlValue={setDtlValue}/>
                );
            case "T3": case "T4": case "T5": case "T6":
                return (
                  <Render2Html contentId={contentId}     activeFlagObj={activeFlagObj} initialItemState={initialItemState}
                               getMstValue={getMstValue} setMstValue={setMstValue}
                               getDtlValue={getDtlValue} setDtlValue={setDtlValue}/>
                );
            case "T7":
                return (
                  <Render3Html contentId={contentId}     activeFlagObj={activeFlagObj}
                               getMstValue={getMstValue} setMstValue={setMstValue}
                               getDtlValue={getDtlValue} setDtlValue={setDtlValue}/>
                );
            case "T8":case "T9":case "T10":
                return (
                  <Render4Html contentId={contentId}     activeFlagObj={activeFlagObj}
                               getMstValue={getMstValue} setMstValue={setMstValue}
                               getDtlValue={getDtlValue} setDtlValue={setDtlValue}/>
                );
            case "T11": case "T13":
                return (
                  <Render5Html contentId={contentId}     activeFlagObj={activeFlagObj}
                               getMstValue={getMstValue} setMstValue={setMstValue}
                               getDtlValue={getDtlValue} setDtlValue={setDtlValue}/>
                );
            case "T99":
                return (
                  <Render6Html contentId={contentId}     activeFlagObj={activeFlagObj}
                               getMstValue={getMstValue} setMstValue={setMstValue}
                               getDtlValue={getDtlValue} setDtlValue={setDtlValue}
                               updateWorkState={updateWorkState}
                               mstActiveFlagObj={mstActiveFlagObj}
                               getMstActiveFlag={getMstActiveFlag} setMstActiveFlag={setMstActiveFlag}
                  />

                );
            default:
                return null;
        }

    }


    /* ****************************************************************************** TabPage Area */

    /* Event ****************************************************************************** */
    const handleMainSave =  () =>  {
        if(isHasPermission===true){
            toast({ type: 'warning', message: '저장 권한이 없습니다.', opt: { position: "top-center"} });
            return;
        }else{

            const dsMstCopy = updateWorkState();  //상태값 체크
            svcSaveData(dsMstCopy).then(() => {
                toast({ type: 'success', message: '저장되었습니다.', opt: { position: "top-center"} });
            });
        }


    }

    const handleModalOpen = () => {
        updateWorkState();
        setIsModalOpen(true);
    }

    const handleModalOpen_manual = () => {
        setIsModalOpen_manual(true);
    }

    //사용자 상세 팝업 닫기
    const handleModal_Close = () => {
        //e.preventDefault();
        setIsModalOpen(false);
    }
    const handleModalClose_manual = () => {
        //e.preventDefault();
        setIsModalOpen_manual(false);
    }
    /* ****************************************************************************** Event */




    return (
      <>
          <NavBar>
              {/*공통 영역*/}
              <div className={styleCom.search_wrap}>
                  <Button variant="Secondary" size="md" addStyle={{width: "110px", height: "40px"}}
                          onClick={()=> handleModalOpen()}>
                      Check Items
                  </Button>
                  <Button variant="Secondary" size="md" addStyle={{width: "110px", height: "40px"}}
                          onClick={()=> handleModalOpen_manual()}>
                      Manual Query
                  </Button>
                  <Button variant="Primary" size="md" addStyle={{width: "110px", height: "40px"}}
                          onClick={()=> handleMainSave()} >
                      저장
                  </Button>
              </div>
              {/*대상자 정보*/}
              <table className={style.info_table} style={{height: "42px", marginBottom:"-10px"}}>
                  <tbody>
                  <tr>
                      <td className={style.info_text_1}> Subject No.</td>
                      <td className={style.info_text_2}>{getMstValue("subjectCd")}</td>
                      <td>
                          <div className={style.verticalLine}/>
                      </td>

                      <td className={style.info_text_1}> Initial</td>
                      <td className={style.info_text_2}>{getMstValue("initial")}</td>
                      <td>
                          <div className={style.verticalLine}/>
                      </td>

                      <td className={style.info_text_1}> Sex/Age</td>
                      <td className={style.info_text_2}>{getMstValue("sex")}/{getMstValue("age")}</td>
                      <td>
                          <div className={style.verticalLine}/>
                      </td>
                      <td className={style.info_text_1}> PCI 시행일</td>
                      <td className={style.info_text_2}>{formatDate(getMstValue("pciDt"))}</td>

                  </tr>
                  </tbody>
              </table>
          </NavBar>
          <div className={styleCom.root_wrap}>

              {/*컨텐츠 영역*/}
              <div className={style.container}>
                  {/* 좌측 탭 목록 영역 */}
                  <div className={style.sidebar}>
                      <Sidebar
                        tabs={tabs}
                        activeTabId={activeTabId} // 활성화된 탭 ID 전달
                        onTabClick={handleTabClick} // 탭 클릭 핸들러 전달
                      />
                  </div>

                  {/* 우측 컨텐츠 영역 */}
                  <div ref={contentRef} className={style.contentArea} style={{width: "1300px"} }>
                      {mainContent(activeTabId)}
                  </div>
              </div>

          </div>
          <Modal
            open={isModalOpen}
            handle_Close={handleModal_Close}
            title="Auto Checklist"
            width ="1200px"
            height="800px"
            isHeader={true}
            isBottom={false}>
              <REG300M1 handle_Close={handleModal_Close} autoCheckObj={autoCheckObj} activeTabId={activeTabId} />
          </Modal>
          <Modal
            open={isModalOpen_manual}
            handle_Close={handleModalClose_manual}
            title="Manual Query"
            width ="1100px"
            height="800px"
            isHeader={true}
            isBottom={false}>
              <REG300M2 handle_Close={handleModalClose_manual} mstId={workId} hsptCd={workHsptCd}/>
          </Modal>
      </>


    );
};


export default REG300F1;
